<template>
    <div v-if = "$store.state.data">
        <h2>Сведения об  остатках денежных средств по состоянию на {{ $store.state.period.date }} (тыс.рублей)</h2>
        <br/>
        <table class="table">
            <thead>
            <tr>
                <th rowspan="2" style="width: 160px;">Всего</th>
                <th colspan="3">в том числе:</th>
            </tr>
            <tr>
                <th>Субсидия на выполнение гос. задания</th>
                <th>Внебюджетные средства</th>
                <th>Целевые субсидии</th>
            </tr>
            <tr>
                <th>1 = гр.2 + гр. 3 + гр. 4</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="$store.state.data">
                <td>{{ $store.state.data.full_sum }}</td>
                <td>{{ $store.state.data.subsidy }}</td>
                <td>{{ $store.state.data.extra_funds }}</td>
                <td>{{ $store.state.data.targeted_subsidies }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {

        data(){
            return {

            }
        },


        created(){
            this.$store.commit("setEoId", document.body.getAttribute("data-eo-id"));
            this.$store.dispatch("getData");
        },


        methods:{

        },
    }
</script>

<style lang="less">

</style>
